var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellFilled64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5 53a6 6 0 01-11.996.225L26.5 53h12zm-6-48A3.5 3.5 0 0136 8.5V11h-7V8.5A3.5 3.5 0 0132.5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 10.5c9.46 0 16.149 7.634 16.149 17.051v7.57a5.15 5.15 0 003.425 4.854l.766.272a4 4 0 012.66 3.769v.83a3.654 3.654 0 01-3.654 3.654H13.154A3.654 3.654 0 019.5 44.846v-.83a4 4 0 012.66-3.77l.766-.271a5.15 5.15 0 003.425-4.853v-7.57h0c0-9.418 6.69-17.052 16.149-17.052z",
    stroke: "currentColor",
    strokeWidth: 3,
    fillOpacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFilled64);
export default __webpack_public_path__ + "static/media/bell-filled-64.ef34e7a5.svg";
export { ForwardRef as ReactComponent };